import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { listAgents } from "@/lib/api";
import { DEMO_AGENTS } from "@/data/mock";

const AgentContext = createContext(null);

export function AgentProvider({ children }) {
  const [created, setCreated] = useState([]);
  const [loading, setLoading] = useState(true);
  const [paletteOpen, setPaletteOpen] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const data = await listAgents();
      setCreated(Array.isArray(data) ? data : []);
    } catch (e) {
      setCreated([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  // All agents = user-created (backend) first, then demo agents.
  const agents = [...created, ...DEMO_AGENTS];

  return (
    <AgentContext.Provider value={{ agents, created, demo: DEMO_AGENTS, loading, refresh, paletteOpen, setPaletteOpen }}>
      {children}
    </AgentContext.Provider>
  );
}

export function useAgents() {
  const ctx = useContext(AgentContext);
  if (!ctx) throw new Error("useAgents must be used within AgentProvider");
  return ctx;
}
